"use client";
import { useTranslations } from "next-intl";

// F7: "yüklenemedi / tekrar dene" şeridi. Eskiden üç sayfa HER yükleme hatasında
// `/login`e atıyordu (500 "çıkış yapıldı" gibi okunuyordu), ikisi hatayı hiç
// yakalamıyordu. Gerçek 401 zaten `lib/api.ts` içinde girişe döner; buraya düşen
// hata sunucu/ağ hatasıdır ve yerinde, tekrar denenebilir gösterilir.
export function LoadError({ onRetry, message }: { onRetry?: () => void; message?: string }) {
  const t = useTranslations("common");
  return (
    <div
      role="alert"
      className="flex items-center justify-between gap-3 rounded-xl px-4 py-3 text-sm"
      style={{ background: "#fef2f2", color: "#b91c1c", border: "1px solid #fecaca" }}
    >
      <span>{message ?? t("loadError")}</span>
      {onRetry && (
        <button
          type="button"
          onClick={onRetry}
          className="shrink-0 rounded-lg px-3 py-1 text-xs font-semibold text-white hover:opacity-90"
          style={{ background: "#b91c1c" }}
        >
          {t("retry")}
        </button>
      )}
    </div>
  );
}
